import Model from '@/models/Model.js';

export default class SectionSettingsTemplate extends Model {
    static entity = 'section_settings_templates';

    static fields() {
        return {
            id: this.attr(null),
            type: this.attr(null),
            week_number: this.attr(null),
            week_visible: this.attr(null),
            day_visible: this.attr(null),
            time_visible: this.attr(null),

            ...super.fields(),

            course_template: this.belongsTo('course_templates', 'course_template_id'),
        };
    }
}
